export default __webpack_public_path__ + "static/media/ghana.2b3708c0.svg";